/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {callWSFunction} from "../APIClient.jsx";


const Volumes = function (volumeId) {

    async function create(name) {

    }

    async function remove() {
        return callWSFunction("volumes.remove", {
            volumeId: volumeId,
        })
    }

    async function applyBackup(backupId) {
        return callWSFunction("volumes.applyBackup", {
            volumeId: volumeId,
            backupId: backupId,
        })
    }

    async function createBackup(backupName) {
        return callWSFunction("volumes.createBackup", {
            volumeId: volumeId,
            backupName: backupName,
        })
    }


    async function attach(nodeId) {

    }

    async function detach() {

    }


    async function doesExist() {

    }

    async function getInfo() {

    }

    async function setStatus(newStatus) {

    }

    async function update(values) {

    }


    return {create, getInfo, doesExist, attach, detach, remove, applyBackup, createBackup}
}

export {Volumes}